import adsumLogo from "@/assets/adsum-logo-light.svg";

const CONTACT_EMAIL = "instantvat@adsum-works.com";

const Discontinued = () => {
  return (
    <main className="grid min-h-screen place-items-center bg-background px-6">
      {/* The text block is centred in the page; the logo sits above it
          without shifting that centre. */}
      <div className="relative w-full max-w-[32rem] text-center">
        <img
          src={adsumLogo}
          alt="Adsum"
          className="absolute bottom-full left-1/2 mb-6 -translate-x-1/2 opacity-40 duration-1000 animate-in fade-in"
          width={64}
          height={15}
        />

        <h1 className="text-[1.375rem] font-normal leading-[1.25] tracking-[-0.025em] text-balance text-foreground duration-700 animate-in fade-in slide-in-from-bottom-1 sm:text-[1.625rem]">
          InstantVAT has been discontinued
        </h1>

        {/* Two deliberate lines rather than letting the sentence wrap
            wherever the viewport happens to break it. */}
        <p className="mx-auto mt-4 max-w-[26rem] text-[0.875rem] leading-[1.45] text-foreground/75 delay-150 duration-700 animate-in fade-in slide-in-from-bottom-1 fill-mode-backwards">
          This service is no longer available.
          <span className="block">
            For enquiries, email{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="whitespace-nowrap text-foreground underline decoration-foreground/40 underline-offset-[5px] transition-colors duration-200 hover:decoration-foreground/70"
            >
              {CONTACT_EMAIL}
            </a>
          </span>
        </p>
      </div>
    </main>
  );
};

export default Discontinued;
